export const FORWARDING = 'forwarding';
export const FEATURE_FLAG = 'FEATURE_FLAG';
export const PUBLIC_DATA = 'PUBLIC_DATA';
